import React from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Skeleton,
  Typography,
} from '@mui/material';
import {
  CartesianGrid,
  ComposedChart,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  Line,
} from 'recharts';
import { Close } from '@mui/icons-material';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';
import { IDocumentRequested } from '../../Interfaces/IDocumentRequested';
import { IDocumentUploaded } from '../../Interfaces/IDocumentUploaded';
import {
  useGetDocumentsDownloaded,
  useGetDocumentsRequested,
  useGetDocumentsUploaded,
} from '../../hooks/reactQuerys/DashboardQueries';

interface IProps {
  keyName: string;
  activeDashboard: string[];
  setActiveDashboard: Function;
}

export const ComposedDocuments: React.FC<IProps> = ({
  keyName,
  activeDashboard,
  setActiveDashboard,
}) => {
  const { documentRequested, isLoadingDocumentRequested } =
    useGetDocumentsRequested();
  const { documentDownloaded, isLoadingDocumentDownloaded } =
    useGetDocumentsDownloaded();
  const { documentUploaded, isLoadingDocumentUploaded } =
    useGetDocumentsUploaded();

  const chartData = () => {
    const aktuellesJahr = new Date().getFullYear();
    const resturnArray: any[] = [];
    //
    if (documentRequested && documentDownloaded && documentUploaded) {
      for (let monat = 0; monat < 12; monat++) {
        const datum = new Date(aktuellesJahr, monat, 1);
        const monatStr = String(monat + 1).padStart(2, '0');

        const currentObject: any = {
          Monat: monatStr,

          Heruntergeladen: documentDownloaded[String(monat + 1)],

          Angefragt: documentRequested[String(monat + 1)],

          Hochgeladen: documentUploaded[String(monat + 1)],
          /*
        Hochgeladen: documentUploadedArray.filter(log => {
          const date = new Date(log.Timestamp);
          return (
            date.getFullYear() === datum.getFullYear() &&
            date.getMonth() === datum.getMonth()
          );
        }).length,
        */
        };

        resturnArray.push(currentObject);
      }
    }

    return resturnArray;
  };

  const onRemove = () => {
    setActiveDashboard([...activeDashboard.filter(x => x !== keyName)]);
  };

  if (
    isLoadingDocumentRequested ||
    isLoadingDocumentDownloaded ||
    isLoadingDocumentUploaded
  ) {
    return <Skeleton width={500} height={500} sx={{ mt: -14 }} />;
  }

  return (
    <>
      <Card variant='outlined'>
        <IconButton sx={{ float: 'right' }} onClick={onRemove}>
          <Close sx={{ fontSize: 14 }} />
        </IconButton>
        <CardContent>
          <Typography>Dokumente (Monate)</Typography>
          <Box
            sx={{
              mt: 5,
              height: { xs: 150, sm: 250, xl: 300 },
              width: { xs: 300, sm: 375, xl: 450 },
            }}
          >
            <ResponsiveContainer width='100%' height='100%'>
              <ComposedChart data={chartData()}>
                <XAxis dataKey='Monat' />
                <YAxis
                  interval='preserveStartEnd' // Damit wir den Y-Achsenbereich automatisch anpassen können
                  //tickCount={10}  // Anzahl der Ticks auf der Y-Achse (du kannst dies anpassen)
                  tickFormatter={(value: number): string =>
                    Math.floor(value).toString()
                  } // Ganzzahliger Formatter
                />
                <Tooltip />
                <Legend />
                <CartesianGrid stroke='#f5f5f5' />
                <Line
                  type='monotone'
                  dataKey='Heruntergeladen'
                  stroke='rgb(46, 125, 50)' // Dynamische Browserfarbe
                />
                <Line
                  type='monotone'
                  dataKey='Angefragt'
                  stroke='rgb(237, 108, 2)' // Dynamische Browserfarbe
                />
                <Line
                  type='monotone'
                  dataKey='Hochgeladen'
                  stroke='#413ea0' // Dynamische Browserfarbe
                />
              </ComposedChart>
            </ResponsiveContainer>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
